import { render } from "./AddBiochemistryTemplate.vue?vue&type=template&id=7ec346a0"
import script from "./AddBiochemistryTemplate.vue?vue&type=script&lang=js"
export * from "./AddBiochemistryTemplate.vue?vue&type=script&lang=js"

import "./AddBiochemistryTemplate.vue?vue&type=style&index=0&id=7ec346a0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__